import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AlertConfig, SiLandingPageModule } from '@simpl/element-ng';
import { SettingsService } from '../../services/settings.service';
import {FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';

import { AuthService } from '../../services/auth-service';
import {AuthMockService} from "../../services/auth.mock.service";

@Component({
  templateUrl: './landing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SiLandingPageModule, TranslateModule, RouterLink, ReactiveFormsModule, FormsModule],
  standalone: true
})
export class LandingComponent {

  readonly availableLanguages = this.settingsService.availableLanguages;
  loginError?: AlertConfig;
  loginForm = this.formBuilder.group({
    username: '',
    password: ''
  });
  showPassword: boolean = false;

  constructor(
    private authService: AuthService,
    private settingsService: SettingsService,
    private formBuilder: FormBuilder
  ) {
  }

  onSubmit(): void {
    // Process checkout data here
    this.authService.login().subscribe({
      error: () => this.loginError = {
        severity: 'danger', message: 'APP.OIDC_ERROR'
      }
    });

  }

  login() {
    this.authService.login().subscribe({
      error: () => this.loginError = {
        severity: 'danger', message: 'APP.OIDC_ERROR'
      }
    });
  }

  logout(){
    this.authService.logout();
  }
}
